import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiInput from './AiInput'

const mapStateToProps = (state, ownProps) => ({
  //childrenE: ownProps.product==='ring'?state['options_er'].options:state['options_eb'].options,
  optionE: ownProps.product==='ring'?state['options_er']:state['options_eb1'],
  font: ownProps.product==='ring'?state['fr']:state['fb1'],
  sc: state.sc,
  loading:state.loading,
  product:ownProps.product,
  maxSliderSize :ownProps.maxSliderSize
                

})


 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value}))),
  onLoadingDone: (() =>{ 
    //console.log('onLoadingDone123',ownProps.product)
  //  dispatch(state_update({attr:'showSticky',value:true}) )
    dispatch(state_update({attr:'loading-'+ownProps.product,value:'done'}) )
  }
  ),
 
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiInput)


// WEBPACK FOOTER //
// ./src/layout/AiInputWrap.js